<template>
  <div>
    <v-layout v-if="!ocultar_titulo_tela" class="systock-breadcrump text-uppercase" align-center>
      <v-flex xs5>
        <v-breadcrumbs>
          <v-breadcrumbs-item>
            <h4 title="Controle de parametrização de fornecedores">
              Controle de parametrização de fornecedores
            </h4>
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-flex>
    </v-layout>

    <div>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="desserts"
        :items-per-page="100"
        class="elevation-2 font-resp-tabela table-full-screen mx-2"
        :fixed-header="true"
        :search="search"
        show-select
        :height="height_data_table"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>
              <v-icon left>mdi-format-list-bulleted-square</v-icon>
              Lista de fornecedores
            </v-toolbar-title>

            <v-divider class="ml-5" inset vertical></v-divider>

            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              style="max-width: 450px"
            />

            <Filtros
              :filtros="filtros"
              @atualizar-filtros="$event => filtros = $event"
              @atualizar-tela-deparametrizacao-fornecedor="inicialize()"
            />

            <v-badge :overlap="selected.length > 0" color="white">
              <template v-slot:badge>
                <span style="color: black" class="font-weight-medium">
                  {{ selected.length }}
                </span>
              </template>
              <v-btn
                small
                class="mr-0 ml-5"
                color="primary"
                @click="abrirEdicaoMultiplos(selected)"
              >
                Vincular Compradores
              </v-btn>
            </v-badge>
          </v-toolbar>
        </template>

        <template v-slot:item.pedido_minino_compra="{ item }">
          {{ Helpers.formatarValor(item.pedido_minino_compra) }}
        </template>

        <template v-slot:item.ativo="{ item }">
          {{ item.ativo === "S" ? "SIM" : "NÃO" }}
        </template>

        <template v-slot:item.calcular_litragem="{ item }">
          {{ item.calcular_litragem ? "SIM" : "NÃO" }}
        </template>

        <template v-slot:item.ressuprimento_manual="{ item }">
          {{ item.ressuprimento_manual === "S" ? "SIM" : "NÃO" }}
        </template>

        <template v-slot:item.fornecedor_local="{ item }">
          {{ item.fornecedor_local ? "SIM" : "NÃO" }}
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-btn @click="abrirEdicao(item)" icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>

    <edit-fornecedor
      :dialogEditFornecedor="dialog"
      :item="editedItem"
      :multiplos_fornecedores_selecionados="selected"
      @fecharDialogEditFornecedor="fecharDialog"
      @incializeDialogEditFornecedor="inicialize"
    ></edit-fornecedor>

    <multiplos-compradores
      :dialogMultiplosCompradores="dialogMultiplos"
      :selected="editedItem"
      :selectsFornecedor="selects"
      @fechar-dialog="fecharDialog()"
      @atualizar-tela-de-fornecedores="inicialize();fecharDialog();"
    ></multiplos-compradores>
  </div>
</template>

<script>
import { getListaFornecedoresFull, getListaCompradoresFull } from "@/api/fornecedor";
import EditFornecedor from "./dialog/EditFornecedor.vue";
import MultiplosCompradores from "./dialog/FornecedoresVsComprador.vue";
import Filtros from "./dialog/Filtros.vue";

export default {
  components: {
    EditFornecedor,
    MultiplosCompradores,
    Filtros
  },
  name: "Fornecedor",
  props: {
    ocultar_titulo_tela: Boolean,
    height_data_table: {
      type: String,
      default: 'calc(100vh - 225px)'
    }
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Id", value: "id" },
        { text: "Razão Social", value: "razao_social" },
        { text: "Ressuprimento Manual", value: "ressuprimento_manual" },
        { text: "Ressuprimento Dias", value: "ressuprimento_qtde_dias" },
        { text: "Comprador", value: "nome_completo" },
        { text: "Forecast (dias)", value: "tempo_forecast" },
        { text: "Pedido mínimo", value: "pedido_minino_compra" },
        { text: "Ativo", value: "ativo" },
        { text: "Calcular Litragem", value: "calcular_litragem" },
        { text: "Tipo Litragem", value: "tipo_litragem" },
        { text: "Fornecedor Local", value: "fornecedor_local" },
        { text: "Ações", value: "acoes" },
      ],
      desserts: [],
      selected: [],
      editedItem: null,
      selects: {
        compradores: {
          items: [],
        },
        fornecedores: {
          items: [],
        },
      },
      filtros: {
        idfamilia_produto: [],
        idcomprador: []
      },
      dialog: false,
      dialogMultiplos: false,
    };
  },
  created() {
    this.inicialize();
  },
  methods: {
    inicialize() {
      this.buscarListaFornecedores();
      this.buscarListaCompradores();
    },

    fecharDialog() {
      this.dialog = false;
      this.dialogMultiplos = false;
      this.editedItem = [];
      this.selected = [];
    },

    abrirEdicaoMultiplos(item) {
      let arrayIdFornecedor = this.Helpers.arrayColumn(item, "id");
      let arrayFornecedor = [];
      arrayIdFornecedor.forEach((el) => arrayFornecedor.push(el));
      this.editedItem = arrayFornecedor;
      this.dialogMultiplos = true;
    },

    abrirEdicao(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    buscarListaFornecedores() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getListaFornecedoresFull(this.filtros)
          .then((fornecedores) => {
            this.desserts = fornecedores;
            this.selects.fornecedores.items = fornecedores;
            this.resetarFiltros();
          })
          .catch(() => this.Helpers.logout())
      );
    },
    buscarListaCompradores() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getListaCompradoresFull(this.filtros)
          .then((compradores) => {
            this.selects.compradores.items = compradores;
            this.resetarFiltros();
          })
          .catch(() => this.Helpers.logout())
      );
    },
    resetarFiltros() {
      this.filtros.idfamilia_produto = [];
      this.filtros.idcomprador = [];
    }
  },
};
</script>

<style>
.autocomplete-fornecedor-com-barra-de-rolagem .v-select__selections {
  min-height: auto;
  max-height: 170px;
  margin-right: -30px !important;
  overflow-x: hidden;
  overflow-y: auto;
  display: block;
}

.autocomplete-fornecedor-com-barra-de-rolagem i {
  visibility: hidden;
}
</style>
